module.exports = __webpack_public_path__ + "static/media/ST9.a349e57d.mp3";